import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export enum DocumentIcon {
  BENCHMARK = 'benchmark',
  BLANK = 'blank',
  CHARGEMASTER = 'chargemaster',
  CLAIM = 'claim',
  DATA_SOURCE = 'data-source',
  NPI = 'npi',
  USAGE = 'usage',
  USAGE_SCHEDULE = 'usage-schedule',
  COST = 'cost',
  ADD_FILE = 'add-file',
  CSV = 'CSV',
  PDF = 'PDF',
  WORD = 'WORD',
  SCHEDULE = 'schedule',
  XLS = 'XLS',
}

let unique = 0;

@Component({
  selector: 'document-icon',
  templateUrl: './document-icon.component.html',
  styleUrls: ['./document-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentIconComponent {
  @Input() type: DocumentIcon = DocumentIcon.USAGE;
  @Input() empty = false;
  @Input() needsAttention = false;
  @Input() compact = false;
  DocumentIcon = DocumentIcon;

  private unique: number;

  constructor(
    readonly location: Location,
    private readonly router: Router,
  ) {
    this.unique = unique++;
  }

  private idFn = of((id: string) => `${id}-${this.unique}`);

  pageGradientId = this.idFn.pipe(map(idFn => idFn('page-gradient')));

  pageMaskId = this.idFn.pipe(map(idFn => idFn('page-mask')));

  backgroundStripeMaskId = this.idFn.pipe(
    map(idFn => idFn('background-stripe-mask')),
  );

  private urlFn = this.router.events.pipe(
    startWith(null),
    map(() => {
      return (id: string) => `url(${this.location.path()}#${id})`;
    }),
  );

  pageGradientUrl = combineLatest([this.urlFn, this.pageGradientId]).pipe(
    map(([urlFn, pageGradientId]) => urlFn(pageGradientId)),
  );

  pageMaskUrl = combineLatest([this.urlFn, this.pageMaskId]).pipe(
    map(([urlFn, pageMaskId]) => urlFn(pageMaskId)),
  );

  backgroundStripeMaskUrl = combineLatest([
    this.urlFn,
    this.backgroundStripeMaskId,
  ]).pipe(
    map(([urlFn, backgroundStripeMaskId]) => urlFn(backgroundStripeMaskId)),
  );
}
